<template>
    <a-form :form="basicForm" v-show="basicStatus == 'process'">
        <a-form-item :label="$t('supervise.templateName')" v-bind="formItemLayout">
            <a-input size="small" v-model="templateName" v-decorator="['templateName',{ rules: [{ required: true, message: $t('supervise.templateName') }] }]"></a-input>
        </a-form-item>

        <a-form-item  :label="$t('supervise.templateDescription')" v-bind="formItemLayout">
            <a-textarea v-model="templateDescription" v-decorator="['templateDescription',{ rules: [{ required: true, message: $t('supervise.templateDescription') }] }]"/>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 3 }" style="margin-top:10px">
            <a-button style="margin-left:10px" type="primary" @click="next">{{$t('global.next')}}</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
    export default {
        name: 'ZAddTemplateBasic',
        props:['basicStatus'],
        data() {
            return{
                templateName: null,
                templateDescription: null,
                basicForm: null,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 6 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 14 },
                    }
                }
            }
        },
        methods: {
            next(){
                let _this = this
                this.basicForm.validateFieldsAndScroll((err) => {
                    if(!err){
                        let param = {}
                        param.templateName = this.templateName
                        param.templateDescription = this.templateDescription
                        _this.$emit('gotoNext',param)
                    }else{
                        console.log(err)
                    }
                })
            },
            init(){
                this.basicForm = this.$form.createForm(this)
            }
        }
    }

</script>